import React from 'react';

import { Box, Typography } from '@mui/material';

import { Testimonial } from '../data/Testimonials';
import { tokens } from '../theme';

function TestimonialQuote({ testimonial }: { testimonial: Testimonial }) {
  const attribution = [testimonial.name, testimonial.role, testimonial.organization]
    .filter(Boolean)
    .join(', ');
  return (
    <Box
      component='figure'
      sx={{
        m: 0,
        p: { xs: 3, md: 4 },
        minWidth: 0,
        // Stitch card: white, soft border, accent edge.
        borderRadius: 3,
        bgcolor: tokens.surfaceLowest,
        border: `1px solid ${tokens.outlineVariant}`,
        borderLeft: `4px solid ${tokens.secondary}`,
        overflowWrap: 'anywhere',
      }}
    >
      <Typography
        component='blockquote'
        variant='body1'
        sx={{ m: 0, color: tokens.onSurface, fontStyle: 'italic' }}
      >
        “{testimonial.quote}”
      </Typography>
      <Typography
        component='figcaption'
        variant='body2'
        sx={{ mt: 1.5, color: tokens.onSurface }}
      >
        <Box
          component='span'
          sx={{ display: 'block', fontWeight: 700 }}
        >
          {attribution}
        </Box>
        <Box
          component='span'
          sx={{ display: 'block', color: tokens.onSurfaceVariant }}
        >
          {testimonial.context}
        </Box>
      </Typography>
    </Box>
  );
}

export default TestimonialQuote;
